import { environment } from '@rtls-environment/environment';
import { AuthConfig } from '@auth0/auth0-angular';

export function buildAuth0Config(): AuthConfig {
	const baseConfig: AuthConfig = {
		domain: environment.auth.auth0ApiUrl,
		authorizationParams: {
			redirect_uri: environment.host,
			audience: environment.auth.audience,
			scope: environment.auth.scope,
		},
		clientId: environment.auth.clientId,
		useRefreshTokens: true,
		useRefreshTokensFallback: true,
		cacheLocation: 'localstorage',
		httpInterceptor: {
			allowedList: [
				{ uri: environment.baseURL },
				{ uri: `${environment.baseURL}/*` },
				{ uri: environment.baseApiURL },
				{ uri: `${environment.baseApiURL}/*` },
			],
		},
	};

	const params = new URLSearchParams(window.location.search);
	const sso = params.get('sso');

	if (!sso) {
		return baseConfig;
	}

	return {
		...baseConfig,
		authorizationParams: {
			...baseConfig.authorizationParams,
			connection: sso,
		},
	};
}
